import { register, getPrefix, storageAvailable } from '../../../Utils'

const CompetenceFilter = el => {
  const prefix = getPrefix(el)
  const searchField = el.querySelector(`.${prefix}search-field`)
  const placeholder = el.querySelector(`.${prefix}placeholder`)
  const placeholderFallback = placeholder.innerText
  const toggler = el.querySelector(`.${prefix}toggler`)
  const popup = el.querySelector(`.${prefix}popup`)
  const reset = el.querySelector(`.${prefix}reset`)
  const competences = el.querySelectorAll(`.${prefix}competence`)
  const competenceLetters = el.querySelectorAll(`.${prefix}letter`)

  const changeSearchInput = (e) => {
    const searchQuery = e.target.value
    const regPattern = new RegExp(`(${searchQuery})`, 'gi')

    competences.forEach(competence => {
      const competenceText = competence.innerText

      if (regPattern.test(competenceText)) {
        competence.classList.toggle('d-none', false)
        const newText = competenceText.replace(regPattern, '<strong>$1</strong>')
        competence.innerHTML = newText
      } else {
        competence.classList.toggle('d-none', true)
      }
    })

    competenceLetters.forEach(letter => {
      letter.classList.toggle('d-none', !letter.querySelectorAll(`.${prefix}competence:not(.d-none)`).length)
    })
  }

  const clickCompetence = (e) => {
    placeholder.innerText = e.target.innerText
    togglePopup()
  }

  competences.forEach(competence => {
    competence.addEventListener('click', clickCompetence)
  })

  const clickReset = () => {
    placeholder.innerText = placeholderFallback
    togglePopup()
  }

  reset.addEventListener('click', clickReset)

  searchField.addEventListener('input', changeSearchInput)

  const togglePopup = () => {
    popup.classList.toggle(`${prefix}is--active`)
  }

  toggler.addEventListener('click', togglePopup)

  if (storageAvailable('localStorage')) {
    if (window.localStorage.getItem('baho_competence_text')) {
      placeholder.innerText = window.localStorage.getItem('baho_competence_text')
    }
  }
}

register('CompetenceFilter', CompetenceFilter)
